import { useState } from 'react'
import { useAuth } from '../hooks/useAuth'

export function Login() {
  const [email, setEmail] = useState('')
  const [sent, setSent] = useState(false)
  const [error, setError] = useState('')
  const { sendMagicLink } = useAuth()

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    try {
      await sendMagicLink(email)
      setSent(true)
    } catch (err) {
      setError('Failed to send magic link. Try again.')
    }
  }

  if (sent) {
    return (
      <div className="page login">
        <div className="login-card">
          <div className="logo">🏨</div>
          <h1>DIGSAFE</h1>
          <p className="subtitle">Check your email</p>
          <p>We sent a login link to <strong>{email}</strong></p>
          <p className="hint">Click the link to log in. No password needed.</p>
          <button className="btn-secondary" onClick={() => setSent(false)}>
            Use a different email
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="page login">
      <div className="login-card">
        <div className="logo">🏨</div>
        <h1>DIGSAFE</h1>
        <p className="subtitle">Hotels as digs — the good kind</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            placeholder="your@email.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="input"
          />
          {error && <p className="error">{error}</p>}
          <button type="submit" className="btn-primary">
            Send login link
          </button>
        </form>
        <p className="hint">No password. We'll email you a magic link.</p>
      </div>
    </div>
  )
}
